import { ProfileIcon } from '@components/icons';
import type { MenuExtendedItem } from '@components/sidebar/types';

import { ROUTES } from '@constants/routes';

import { useApp } from '@system/app';

export const SidebarFooterMenuProfile = (): MenuExtendedItem[] => {
  const { me } = useApp();

  return [
    {
      title: me?.full_name ?? 'Профиль',
      icon: <ProfileIcon />,
      link: ROUTES.PROFILE,
      route: ROUTES.PROFILE,
    },
  ];
};
